import styled from 'styled-components';
import MuiCardHeader from "@material-ui/core/CardHeader";

export const StyledMuiCardHeader = styled(MuiCardHeader)`
  && {
    flex-direction: column;
    padding: 30px 30px 0 30px;

    .MuiCardHeader-content {
      align-self: flex-start;
      color: #26427C;
    }

    .MuiCardHeader-title {
      font-weight: 500;
      font-size: 1.5em;
      line-height: 1.5em;
    }
  }
`;
